import { DownOutlined } from '@ant-design/icons'
import { Dropdown, Table } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { AllocationItemV2 } from 'Modules'

import { convertNumberToDateTime } from 'utils/datetime'

interface AllocationDropdownCellProps {
  items: AllocationItemV2[]
  totalDisplay: number
}

const AllocationDropdownCell = ({ items, totalDisplay }: AllocationDropdownCellProps) => {
  const totalText = totalDisplay?.toLocaleString() ?? '0'

  if (!items?.length) {
    return <span style={{ textAlign: 'right', display: 'block' }}>{totalText}</span>
  }

  const columns: ColumnsType<AllocationItemV2> = [
    { title: 'Value', dataIndex: 'value', key: 'value', render: (v) => v?.toLocaleString() ?? '0' },
    {
      title: 'Sign Date',
      dataIndex: 'signDate',
      key: 'signDate',
      render: (v) =>
        convertNumberToDateTime(Number(v))?.utc().format('YYYY-MM-DD h:mm A [UTC]') ?? '-',
    },
  ]

  return (
    <Dropdown
      dropdownRender={() => (
        <div
          style={{
            background: '#fff',
            padding: 8,
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            borderRadius: 4,
          }}
        >
          <Table
            dataSource={items}
            columns={columns}
            rowKey={(_, i) => String(i)}
            pagination={false}
            size="small"
            bordered
          />
        </div>
      )}
      trigger={['hover']}
      mouseEnterDelay={0.1}
      mouseLeaveDelay={0.1}
    >
      <span style={{ cursor: 'pointer', textAlign: 'right', display: 'block' }}>
        {totalText} <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
      </span>
    </Dropdown>
  )
}

export default AllocationDropdownCell
